import * as types from './mutation-types'
import Ls from "@/services/ls";

export default {
    [types.ADD_ORDER_TO_CART] (state, data) {
        state.cart = [...state.cart, data]
    },
    [types.SAVE_CART] (state) {
        Ls.set('orders', JSON.stringify(state.cart))
    },
    [types.EDIT_ORDER_IN_CART] (state, data) {
        let orders = state.cart?.filter((order,index) => index != data.index)
        state.cart = [...orders, data.order]
    },
    [types.DELETE_ORDER_FROM_CART] (state, _index) {
        let orders = state.cart?.filter((order,index) => index != _index)
        state.cart = orders
    },
    [types.REMOVE_ALL_ORDER_FROM_CART] (state) {
        state.cart = []
    },
}

